module.exports = __webpack_public_path__ + "static/media/Need.66bf77c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Need.png
// module id = 566
// module chunks = 0